var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('home-banner'),_vm._v(" "),_c('home-group'),_vm._v(" "),_c('home-words')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }